// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import ElementUI from 'element-ui';
import './assets/css/element-green/index.css';
import router from './router';
import 'babel-polyfill';
import echarts from 'echarts';
import App from './App';
import BaseMixin from './mixins/commonMixin.js';
import store from './store';
import Mint from 'mint-ui';
// import { Navbar, TabItem } from 'mint-ui';
import 'mint-ui/lib/style.css';
// import commonHandle from 'components/common/common';

Vue.config.productionTip = false;
Vue.mixin(BaseMixin);
/* eslint-disable no-new */
Vue.use(ElementUI);
Vue.use(Mint);

// Vue.component(Navbar.name, Navbar);
// Vue.component(TabItem.name, TabItem);
Vue.prototype.$axios = axios;
Vue.prototype.$echarts = echarts;
// router.beforeEach((to, from, next) => {
//   if (to.path !== '/login') {
//     commonHandle.checkLogout('/ota/check_user_log_status', router.app);
//   }
//   next();
// });
new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js